module.exports = __webpack_public_path__ + "static/img/hx5.3f254ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/hx5.png
// module id = wACY
// module chunks = 1